export const GPS_COMMAND: string = 'ForceGPS';